<template>

  <v-autocomplete v-model="clubSelected"
                  :label="label"
                  :placeholder="label"
                  :items="items"
                  item-text="itemtext"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  hide-no-data
                  :filter="v => v"
                  :search-input.sync="search"></v-autocomplete>

</template>

<script>

import { getSportInfos } from '../../helpers/get-sport-infos'

export default {
  name: 'ClubSelector',
  props: ['sportID', 'label', 'reset'],
  data () {
    return {
      previousLetterInput: '',
      search: '',
      loading: false,
      items: [],
      clubSelected: null
    }
  },
  watch: {
    search (s) {
      if (!this.clubSelected) {
        this.previousLetterInput = s
        setTimeout(() => {
          if (s === this.previousLetterInput) {
            // Reset selection on empty search input
            if (s === '') {
              this.clubSelected = null
            } else {
              this.loading = true
              this.items = []
              // Fetch new items, let the watcher add them to the list
              this.$store.dispatch('fetchClubs', {
                name: this.search || '',
                sportID: this.sportID
              })
                .then(resp => {
                  for (const item of resp.items) {
                    item.itemtext = `${item.alias} - ${getSportInfos({id: item.sportID}).names['default']}`
                    this.items.push(item)
                  }
                })
                .catch(err => { console.error('Failed to fetch clubs: ', err) })
                .finally(() => { this.loading = false })
            }
          }
        }, 250)
      }
    },
    'clubSelected' () {
      this.$emit('clubSelected', this.clubSelected)
    },
    'reset' () {
      this.previousLetterInput = ''
      this.search = ''
      this.loading = false
      this.items = []
      this.clubSelected = null
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/ClubSelector.vue